var _defs, _path, _g, _path2, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDocx = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 270,
  height: 155
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "docx_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h121v120.999H0z",
  "data-name": "Rectangle 127"
})))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#f5f5f5",
  d: "M0 0h270v155H0z",
  "data-name": "Rectangle 122"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 232"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#docx_svg__a)",
  "data-name": "Group 231",
  transform: "translate(74.5 17)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M120.5 60.5a60 60 0 1 1-60-60 60 60 0 0 1 60 60",
  "data-name": "Path 2867"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#bcc1c9",
  d: "M60.5 121a60.22 60.22 0 0 1-33.827-10.332A60.67 60.67 0 0 1 4.755 84.049a60.42 60.42 0 0 1 5.578-57.375A60.68 60.68 0 0 1 36.951 4.755a60.42 60.42 0 0 1 57.376 5.578 60.67 60.67 0 0 1 21.918 26.617 60.42 60.42 0 0 1-5.578 57.375 60.67 60.67 0 0 1-26.617 21.92A60.1 60.1 0 0 1 60.5 121m0-120a59.22 59.22 0 0 0-33.266 10.162A59.67 59.67 0 0 0 5.676 37.34a59.42 59.42 0 0 0 5.486 56.426 59.68 59.68 0 0 0 26.179 21.557 59.42 59.42 0 0 0 56.427-5.486 59.67 59.67 0 0 0 21.557-26.177 59.42 59.42 0 0 0-5.486-56.426A59.67 59.67 0 0 0 83.661 5.676 59.1 59.1 0 0 0 60.5 1",
  "data-name": "Path 2868"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#353c3c",
  d: "M78.259 88.662H42.73a5.044 5.044 0 0 1-4.929-4.93V37.268a5.04 5.04 0 0 1 4.929-4.93h22.96a4.8 4.8 0 0 1 1.962.412 5.2 5.2 0 0 1 1.571 1.062l12.5 12.5a5.1 5.1 0 0 1 1.062 1.572 4.8 4.8 0 0 1 .415 1.966v33.882a5.045 5.045 0 0 1-4.931 4.93Zm-35.5-1.7h35.478A3.347 3.347 0 0 0 81.5 83.7V50.833H67.311a2.86 2.86 0 0 1-2.81-2.905v-13.89H42.76A3.344 3.344 0 0 0 39.5 37.3v46.4a3.346 3.346 0 0 0 3.261 3.258Zm24.576-37.829H81.42a3 3 0 0 0-.188-.56v-.009a3.4 3.4 0 0 0-.71-1.053l-12.494-12.49a3.5 3.5 0 0 0-1.055-.712h-.007a3 3 0 0 0-.765-.228v13.87a1.16 1.16 0 0 0 1.134 1.182",
  "data-name": "Path 2869"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#62061f",
  d: "M71.867 74.899H49.134a.85.85 0 0 1-.85-.85.85.85 0 0 1 .85-.85h22.733a.85.85 0 0 1 .85.85.85.85 0 0 1-.85.85",
  "data-name": "Line 124"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#62061f",
  d: "M71.867 65.232H49.134a.85.85 0 0 1-.85-.85.85.85 0 0 1 .85-.85h22.733a.85.85 0 0 1 .85.85.85.85 0 0 1-.85.85",
  "data-name": "Line 125"
})))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#006094",
  d: "M196 0h74v31h-74z",
  "data-name": "Rectangle 18371"
})), _text || (_text = /*#__PURE__*/React.createElement("text", {
  fill: "#fff",
  fontFamily: "Lato-Bold, Lato",
  fontSize: 14,
  fontWeight: 700,
  transform: "translate(233 21)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: -20.275,
  y: 0
}, "DOCX"))));
export { SvgDocx as ReactComponent };
export default __webpack_public_path__ + "a728243b3486b08dc964df02b61a1810.svg";